import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { logger } from '../../../common/utils/logger';

export const onAddPinDismissClick: () => AnalyticsEventPayload = (): AnalyticsEventPayload => {
	try {
		return {
			action: 'clicked',
			actionSubject: 'aiSearchBookmarkAddDismiss',
			eventType: 'ui',
		};
	} catch (error) {
		logger.error({ error, functionName: 'onAddPinDismissClick' });
		return {};
	}
};
